<template>
  <el-dialog
      :title="setId?'修改评分':'创建评分'"
      :visible.sync="subdialogDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="600"
      center>
    <el-form :model="scoreForm" :rules="rules" ref="scoreForm" label-width="100px">
      <el-form-item label="成绩" prop="name">
        <el-input v-model="scoreForm.name" placeholder="请输入成绩"></el-input>
      </el-form-item>
      <el-form-item label="分值" prop="score">
        <el-input type="number" v-model.number="scoreForm.score" placeholder="请输入分值"></el-input>
      </el-form-item>
      <el-form-item class="flex align-center justify-around" label-width="0">
        <el-button class="padding-lr-xl" @click="resetForm('scoreForm')">取消</el-button>
        <el-button class="padding-lr-xl" type="primary" @click="submitForm('scoreForm')">提交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {scoreValueAdd} from "@/api/projectOffice";

export default {
  name: "scoreItemDialog",
  props: {
    subdialogDialog: {
      type: Boolean,
      default: false
    },
    setId: {
      type: Number,
      default() {
        return 0;
      }
    },
    setItem: {
      type: Object
    }
  },
  data() {
    return {
      scoreForm: {
        name: '',
        score:'',
      },
      rules: {
        name: [
          {required: true, message: '请输入成绩', trigger: 'blur'},
        ],
        score: [
          {required: true, message: '请输入分值', trigger: 'blur'},
        ],
      }
    }
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit('cancelDialog', false)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    async submitData(formName) {
      let _state = await scoreValueAdd(
          this.scoreForm.name,
          this.scoreForm.score,
          this.setId ? this.setId : ''
      );
      this.$message.success(_state.msg);
      this.$refs[formName].resetFields();
      this.$emit("cancelDialog", true);
    }
  },
  watch: {
    setItem() {
      this.scoreForm = {
        name: this.setItem.name,
        score: Number(this.setItem.score)
      };
    }
  }
}
</script>

<style scoped lang="scss">

</style>